<template lang="">
    <v-card>
        <s-crud
            :config="config"
            title="Creación de Periodos"
            :filter="filter"
            search-input
            add
            edit
            remove
            @save="save($event)"
            ref="scrudCreationPeriods"
            @addEvent="addEvent()"
            @rowSelected="rowSelected($event)"
            @EditEvent="editEvent($event)"
        >
            <template v-slot:filter>
                <v-container>
                    <v-row style="margin-bottom: 5px;">
                        <v-col cols="12" md="4">
                            <s-select-definition
                                :def="1537"
                                label="Sub Periodo"
                                v-model="filter.PdsType"
                                clearable
                                />
                        </v-col>
                        <v-col cols="12" md="4">
                            <s-text label="Nombre"></s-text>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot="props">
                <v-container>
                    <v-row > 
                        <v-col class="s-col-form" cols="6" md="3" lg="2">
                            <s-text type="number" v-model="item.PdsAnio" label="Año"></s-text>
                        </v-col>                                       
                        <v-col class="s-col-form" cols="6" md="3" lg="2">
                            <s-select-definition
                                :def="1537"
                                label="Sub Periodo"
                                v-model="item.PdsType"
                                />
                        </v-col>
                        <v-col class="s-col-form" cols="12" md="3" lg="2">
                            <s-text label="Nombre de Sub Periodo" v-model="item.PdsName"></s-text>
                        </v-col>
                        <v-col class="s-col-form" cols="6" md="3" lg="2">
                            <s-date
                                v-model="item.PdsDateBegin"
                                label="Fecha Inicio de Contabilización"
                                />
                        </v-col>
                        <v-col class="s-col-form" cols="6" md="3" lg="2">
                            <s-date
                                v-model="item.PdsDateEnd"
                                label="Fecha Fin de Contabilización"
                                />
                        </v-col>
                        <v-col class="s-col-form" cols="12" md="3" lg="2">
                            <s-select-definition                                
                                :def="1538"
                                label="Estado"
                                v-model="item.PdsStatus"
                                />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>
        <v-dialog v-model="dialogPeriods" max-width="400">
            <v-card>
                <s-toolbar label="Cantidad de Periodos" dark color="#8e8f91" close @close="dialogPeriods = false" save @save="savePeriods()"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-text type="number" label="Cantidad de Periodos que desea Crear" v-model="periods" autofocus></s-text>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <AlertSunshine :dialog="dialogLoading" :totalItems="totalItems" :countItems="countItems"/>
    </v-card>

</template>

<script>

import SText from '../../components/Utils/SText.vue';
import CreationPeriods from '../../services/HumanResource/CreationPeriods';
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import { DateTime } from 'luxon';

export default {
    components: {
        SText,
        sToolbarPerson
    },
    data() {
        return {
            isUpdate: false,
            totalItems: 0,
            countItems: 0,
            dialogLoading: false,
            itemBackup: {},
            filter: {
                PdsDateBegin: '',
                PdsDateEnd: '',
                PdsType: 1,
            },
            dialogPeriods: false,
            item: {
                PdsID: 0,
                SecStatus: 1
            },
            periods: 1,
            config: {
                service: CreationPeriods,
                model: {
                    PdsID: "ID",
                    PdsDateBegin: "date",
                    PdsDateEnd: "date",
                },
                headers: [
                    { text: "ID", value: "PdsID" },
                    { text: "Nombre", value: "PdsName" },
                    { text: "Año", value: "PdsAnio" },
                    { text: "Tipo", value: "PdsTypeName" },
                    { text: "Estado", value: "PdsStatusName" },
                    { text: "Fecha Inicio", value: "PdsDateBegin" },
                    { text: "Fecha Fin", value: "PdsDateEnd" },
                ]
            }
        }
    },
    methods: {
        save(item){
            this.item.PdsName = this.$fun.trimFull(this.item.PdsName, true, "-");
            this.item.UsrCreateID = this.$fun.getUserID();
            if(this.isUpdate){
                item.save();
            }else{
                this.dialogPeriods = true;
            }
        },
        async savePeriods() {
            this.dialogLoading = true;
            this.totalItems = this.periods ? this.periods : 0;
            this.countItems = 0;

            if (this.periods) {
                const baseItem = { ...this.item };
                const baseDateBegin = DateTime.fromISO(baseItem.PdsDateBegin);
                const baseDateEnd = DateTime.fromISO(baseItem.PdsDateEnd);
                const basePdsNumber = parseInt(baseItem.PdsName.split('-')[1]);

                for (let i = 0; i < this.periods; i++) {
                    let newItem = { ...baseItem };
                    let newDateBegin, newDateEnd;

                    if (baseItem.PdsType == 1) {
                        // Tipo semanal: sumar 7 días por cada periodo
                        newDateBegin = baseDateBegin.plus({ days: i * 7 });
                        newDateEnd = baseDateEnd.plus({ days: i * 7 });

                    } else if (baseItem.PdsType == 2) {
                        // Tipo mensual: sumar i meses desde el inicio del primer periodo
                        newDateBegin = baseDateBegin.plus({ months: i }).startOf('month');
                        newDateEnd = newDateBegin.endOf('month');
                    }

                    newItem.PdsDateBegin = newDateBegin.toISODate();
                    newItem.PdsDateEnd = newDateEnd.toISODate();
                    newItem.PdsName = `${baseItem.PdsName.split('-')[0]}-${String(basePdsNumber + i).padStart(2, '0')}`;

                    await CreationPeriods.save(newItem, this.$fun.getUserID()).then(res => {
                        if (res.status == 200) {
                            this.countItems++;
                        }
                    });
                }

                this.dialogLoading = false;
                this.$fun.alert("Periodos creados con éxito", "success");
                this.$refs.scrudCreationPeriods.refresh();
            }

            this.dialogPeriods = false;
        },
        addEvent() {
            this.isUpdate = false;
            this.item = {
                PdsID: 0,
                SecStatus: 1
            };

            if (this.itemBackup.PdsType == 1) {
                let newDateBegin = new Date(this.itemBackup.PdsDateBegin);
                newDateBegin.setDate(newDateBegin.getDate() + 7);
                
                let newDateEnd = new Date(this.itemBackup.PdsDateEnd);
                newDateEnd.setDate(newDateEnd.getDate() + 7);

                const basePdsNumber = parseInt(this.itemBackup.PdsName.split('-')[1]);

                this.item.PdsType = this.itemBackup.PdsType;
                this.item.PdsAnio = this.itemBackup.PdsAnio;
                this.item.PdsName = `${this.itemBackup.PdsName.split('-')[0]}-${String(basePdsNumber + 1).padStart(2, '0')}`;
                this.item.PdsDateBegin = newDateBegin.toISOString().split('T')[0];
                this.item.PdsDateEnd = newDateEnd.toISOString().split('T')[0];

            } else if (this.itemBackup.PdsType == 2) {
                const currentBegin = DateTime.fromISO(this.itemBackup.PdsDateBegin);
                const nextMonth = currentBegin.plus({ months: 1 }).startOf('month');
                const endOfNextMonth = nextMonth.endOf('month');

                const basePdsNumber = parseInt(this.itemBackup.PdsName.split('-')[1]);

                this.item.PdsType = this.itemBackup.PdsType;
                this.item.PdsAnio = nextMonth.year;
                this.item.PdsName = `${this.itemBackup.PdsName.split('-')[0]}-${String(basePdsNumber + 1).padStart(2, '0')}`;
                this.item.PdsDateBegin = nextMonth.toISODate();
                this.item.PdsDateEnd = endOfNextMonth.toISODate();
            }

        },
        editEvent() {
            this.isUpdate = true;
            this.item = {...this.itemBackup};
        },
        rowSelected(item) {
            if(item !== null){
                this.itemBackup = item[0];
            }else{
                this.itemBackup = {};
            }
        }
    }
}

</script>